import type { PublishersContent } from '../../content/sections/publishers.js';
import { ApiError } from '../../lib/http.js';

/* Mensagem para erros do provisionamento de publisher (admin-created — ADR-0483). Os códigos vêm
   do admin-service (que repassa/mapeia os do licensing). Slug reservado NÃO aparece aqui: este
   caminho staff PERMITE reservados de propósito (anti-squatting só barra o self-service).
   `labels` vem de `usePublishersContent().provisionErrors` — o call site (`provision-publisher-
   modal.tsx`) resolve a copy no idioma corrente e passa aqui, já que esta função é um helper
   puro fora de render (não pode chamar `useBilingual` diretamente). */
export function publisherProvisionErrorMessage(
  err: unknown,
  labels: PublishersContent['provisionErrors'],
): string {
  if (err instanceof ApiError) {
    switch (err.code) {
      case 'owner_not_found':
        return labels.ownerNotFound;
      case 'invalid_slug':
        return labels.invalidSlug;
      case 'slug_taken':
        return labels.slugTaken;
      case 'already_publisher':
        return labels.alreadyPublisher;
      case 'conflict':
        return labels.conflict;
      case 'unauthorized':
        return labels.unauthorized;
      case 'network':
        return labels.network;
      default:
        return labels.generic;
    }
  }
  return labels.unexpected;
}
